import CheckmateApiClient from '../../../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new CheckmateApiClient();


export const useGetSameCaseKey = 'get-same-case';

export const useGetSameCase = (sameCaseGuid: string | undefined, caseFileModelId: number) => {
    return useQuery({
        queryKey: [useGetSameCaseKey, sameCaseGuid, caseFileModelId],
        queryFn: async () => {
            if (!sameCaseGuid) {
                return;
            }

            const response = await _apiClient.getSameCase(sameCaseGuid, caseFileModelId);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve the cases for this same case.');
            }

            return response.payload;
        },
        enabled: !!sameCaseGuid && !!caseFileModelId && caseFileModelId!> 0,
        cacheTime: 0,
        staleTime: 0,
    });
};
